import type {ReactAction} from '@netx/core/bootstrap';
import {faCube} from '@fortawesome/pro-solid-svg-icons';
import {canCreateTMSObjectFromCurrentCart} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Create tms object package from cart contents
 * @param params
 * @returns Action
 */
export const cartActionCreateTMSObjectPackage = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-create-tms-object-package',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.CREATE_TMS_OBJECT_PACKAGE),
	enableTest: canCreateTMSObjectFromCurrentCart,
	icon: faCube,
	get label() {
		return CART_CURRENT_ACTION_LABELS.CREATE_TMS_OBJECT_PACKAGE;
	},
	...params,
});

export default cartActionCreateTMSObjectPackage;
